import React from "react";
import './Loader.scss';

const Loader = (props) => (
	<div className="loader" {...props}>
	</div>
);

export default Loader;